import { render, staticRenderFns } from "./ElementVCam.vue?vue&type=template&id=4aa0587e&scoped=true&"
import script from "./ElementVCam.vue?vue&type=script&lang=js&"
export * from "./ElementVCam.vue?vue&type=script&lang=js&"
import style0 from "./ElementVCam.vue?vue&type=style&index=0&id=4aa0587e&lang=css&v-html=true&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa0587e",
  null
  
)

export default component.exports